module.exports = __webpack_public_path__ + "img/sdk-architecture.fe7f4b1b.svg";